import { render, staticRenderFns } from "./aiGenerateTaskModal.vue?vue&type=template&id=4fff7f67&scoped=true&"
import script from "./aiGenerateTaskModal.vue?vue&type=script&lang=js&"
export * from "./aiGenerateTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./aiGenerateTaskModal.vue?vue&type=style&index=0&id=4fff7f67&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff7f67",
  null
  
)

export default component.exports